import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  children?: (params: { isOpen: boolean }) => React.ReactNode;
  name?: string;
  amount?: number;
  // 유로 송금 프로포마의 상품 대금은 유로
  currency?: "KRW" | "EUR";
  index?: number;
  hasData?: boolean;
  defaultOpen?: boolean;
}

function OrderHistoryInvoiceToggleBar({
  children,
  name,
  amount = 0,
  currency = "KRW",
  index,
  hasData = true,
  defaultOpen = false,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);
  const { tTitle, tCurrencyKrw, tCurrencyString, isKor } = useI18nHelper();
  return (
    <Flex flexDirection={"column"} gap={"4px"}>
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        onClick={() => {
          if (!hasData) return;
          setIsOpen((prev) => !prev);
        }}
        cursor={hasData ? "pointer" : "not-allowed"}
        _hover={{
          background: hasData ? "#F7F9FA" : "inherit",
        }}
        _active={{
          background: hasData ? "#F0F0F0" : "inherit",
        }}
        paddingY={"4px"}
      >
        <Flex alignItems={"center"} flex={1}>
          <Box padding={"2px"}>
            <CustomIcon
              src={isOpen ? "caret-down" : "caret-right"}
              width={24}
              height={24}
              color={hasData ? "#444444" : "#C0C0C0"}
            />
          </Box>
          <Text
            textStyle={"body-md-semi-bold"}
            color={"#363636"}
            noOfLines={1}
            maxWidth={"70%"}
          >
            {name ??
              `${tTitle("proforma")} ${index}
            ${isKor ? "차" : ""}`}
          </Text>
        </Flex>
        <Text
          textStyle={"body-md-bold"}
          color={"#444444"}
          whiteSpace={"nowrap"}
        >
          {amount === 0
            ? "-"
            : currency === "EUR"
            ? tCurrencyString(amount, { type: "SYMBOL", code: "EUR" })
            : tCurrencyKrw(amount)}
        </Text>
      </Flex>
      {children?.({ isOpen })}
    </Flex>
  );
}

export default OrderHistoryInvoiceToggleBar;
